export const closeTeamGame = () => {
    const teamGameContainer = document.getElementById('team-game');

    if (teamGameContainer) {
        teamGameContainer.parentNode.removeChild(teamGameContainer);

        window.teamGameNotifications();
    }
};
